import qs from 'qs'
import axios from 'axios'

export const moduleService = ({
  listModules (token, courseMasterId) {
    return axios.get('/api/modules?courseMasterId=' + courseMasterId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getSingleModule (token, moduleId) {
    return axios.get('/api/module/single?moduleId=' + moduleId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createModule (token, moduleObj) {
    // var stringifiedObj = qs.stringify(moduleObj)
    return axios.post('/api/module/create', moduleObj, {headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }})
  },
  updateModule (token, moduleObj) {
    return axios.put('/api/module/update', moduleObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteModule (token, moduleId) {
    return axios.delete('/api/module/delete?moduleId=' + moduleId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  reIndexModule (token, moduleObj) {
    var stringifiedObj = qs.stringify(moduleObj)
    return axios.put('/api/Module/ReIndexLessons', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  importLesson (token, formDataObj) {
    return axios.post('/api/ImportData/ImportModule', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  importElements (token, formDataObj) {
    return axios.post('/api/ImportData/ImportElements', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getM365Module (token, courseMasterId) {
    return axios.get('/api/Module/ContentOfTheDay?courseMasterId=' + courseMasterId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  listCurrentAndFutureModules (token, courseMasterId) {
    return axios.get('/api/Module/ListCurrentAndFutureModules?courseMasterId=' + courseMasterId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getCourseJourneyDataForAssesment (token, elementId, getAll = false) {
    return axios.get(`/api/Module/GetCourseJourneyDataForAssesment?elementId=${elementId}&GetAll=${getAll}`, {headers: {'Authorization': 'Bearer ' + token}})
  }
})

/* Module Object Params - Use the below object structure while POSTing/PUTting the object to apis
  {
    ModuleId: moduleObj.ModuleId,
    CourseMasterId:  moduleObj.CourseMasterId ?? Guid.Empty,
    Title: moduleObj.Title,
    IsBonusContent: moduleObj.IsBonusContent ?? false,
    IsOptional: moduleObj.IsOptional ?? false,
    IsPublished: moduleObj.IsPublished ?? false,
    IsUnlocked: moduleObj.IsUnlocked ?? false,
    Index: moduleObj.Index ?? 0,
    CreatedTS: moduleObj.CreatedTS,
    UpdatedTS: moduleObj.UpdatedTS,
    ReleaseDate: moduleObj.ReleaseDate ?? DateTime.MinValue,
    IsReleased: moduleObj.ReleaseDate != null ? moduleObj.ReleaseDate.Value <= DateTime.UtcNow : false
  };
*/



// WEBPACK FOOTER //
// ./src/server-util/module-service.js